/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint state dictionary
 */
export enum FalconComplaintState {
  Closed = 0,
  Open,
  Terminal
}
